import { constants } from "../../../constants";

export default class OpenCashier {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    EZUGI_handler() {
        this.gb.emitters.emit.web.openCashier();
    }

    PT_handler(payload) {
        // if (this.gb.walletCode && this.gb.walletCode !== constants.AMELCO) { // emit if wallet provider is not AMELCO
            const actions = ['quick_deposit','deposit','bank']
            if (payload && payload.pageID && actions.includes(payload.pageID)) {
                this.gb.emitters.emit.web.openCashier();
            }

            if (payload && payload.url) {
                this.gb.queryParams.cashierUrl = payload.url;
            }
        //}
    }

    SPINOMENAL_handler(data) {
        if (data.data.type && data.data.type === 'cashier') {
            this.gb.emitters.emit.web.openCashier();
        }
    }

    _default() {
        this.gb.emitters.emit.web.openCashier();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.PRAGMATIC_PLAY:
                event["openCashier"] = this._default;
                break;
            case constants.SLINGO:
                event["goToDeposit"] = this._default;
                break;
            case constants.QS:
            case constants.RELAX:
                event["gprg_OpenQuickDeposit"] = this._default;
                break;
            case constants.IGT:
                event["rgs2custDeposit"] = this._default;
                break;
            case constants.MGS:
                event["launchbanking"] = this._default;
                break;
            case constants.THUNDER:
                event["makedeposit"] = this._default;
                break;
            case constants.BP:
                event["showDeposit"] = this._default;
                break;
            case constants.EZUGI:
                event["cashier"] = this.EZUGI_handler;
                break;
            //case constants.GSBINGO:
            case constants.GSPOKER:
                event["showDeposit"] = this._default;
                break;
            case constants.BGS:
                event["goToDeposit"] = this._default;
                break;
            case constants.RGU:
                event["goToDeposit"] = this._default;
                break;
            case constants.RAW:
                event["goToDeposit"] = this._default;
                break;
            case constants.HB:
                event["goToDeposit"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["CASHIER"] = this._default;
                break;
            case constants.SYN:
                event["g2p.goToCashier"] = this._default;
                break;
            case constants.RST:
                event["goToDeposit"] = this._default;
                break;
            case constants.PT:
                event["ucip.openpage.g2wOpenPageCommand"] = this.PT_handler;
                break;
            case constants.NLC:
                event["deposit"] = this._default;
                break;
            case constants.YGG:
                event["deposit/show"] = this._default;
                break;
            case constants.HBN:
                event["gotoCashier"] = this._default;
                event["goToDeposit"] = this._default;
                break;
            case constants.SPINOMENAL:
                event["linkRedirect"] = this.SPINOMENAL_handler;
                break;
            case constants.HNR:
                event["gotoCashier"] = this._default;
                event["goToDeposit"] = this._default;
                break;
            case constants.PUSH:
                event["gotoAccount"] = this._default;
                break;
            default:
                event["cashier"] = this._default;
                event["openCashier"] = this._default;
        }

        return event;
    }
}
